import React from "react"
import Layout from "../templates/layout"

export default function Security({ location }) {
  return (
    <Layout
      location={location}
      containerClassName="mx-auto max-w-6xl px-8"
    >
      <div className="max-w-3xl">
          <h1 className="mt-6 md:mt-12 mb-4 max-w-lg">
            Responsible Disclosure Policy
          </h1>
          <p className="mb-3">
            Data security is a top priority for Bankjoy, and Bankjoy believes that
            working with skilled security researchers can identify weaknesses in any
            technology.
          </p>
          <p>
            If you believe you've found a security vulnerability in Bankjoy’s
            service, please notify us; we will work with you to resolve the issue
            promptly.
          </p>
          <h3 className="mt-6 md:mt-16 mb-4">Disclosure Policy</h3>
          <div>
              <ul className="list-disc ml-4 md:ml-5">
                  <li className="mb-2">If you believe you’ve discovered a potential vulnerability, please let us know by emailing us at "email for disclosing vulnerabilities". We will acknowledge your email within <span className="bg-gray-200 px-1.5 py-1 rounded-sm">SLA for disclosure acknowledgement.</span></li>
                  <li className="mb-2">Provide us with a reasonable amount of time to resolve the issue before disclosing it to the public or a third party. We aim to resolve critical issues within <span className="bg-gray-200 px-1.5 py-1 rounded-sm">SLA for disclosure resolution</span> of disclosure.</li>
                  <li className="mb-2">Provide us with a reasonable amount of time to resolve the issue before disclosing it to the public or a third party. We aim to resolve critical issues within <span className="bg-gray-200 px-1.5 py-1 rounded-sm">SLA for disclosure resolution</span> of disclosure.</li>
                  </ul>
          </div>
          <h3 className="mt-6 md:mt-16 mb-4">Exclusions</h3>
          <p className="mb-4">While researching, we’d like you to refrain from:</p>
          <div>
              <ul className="list-disc ml-4 md:ml-5">
                  <li className="mb-2">Distributed Denial of Service (DDoS)</li>
                  <li className="mb-2">Spamming</li>
                  <li className="mb-2">Social engineering or phishing of Bankjoy employees or contractors</li>
                  <li className="mb-2">Any attacks against Bankjoy’s physical property or data centers</li>
                  </ul>
                  <p className="mt-4">Thank you for helping to keep Bankjoy and our users safe!</p>
          </div>

          <h3 className="mt-6 md:mt-16 mb-4">Changes</h3>
          <p className="mb-3">
          We may revise these guidelines from time to time. The most current version of the guidelines will be available at <span className="bg-gray-200 px-1.5 py-1 rounded-sm">public URL for the responsible disclosure guidelines/policy.</span>
          </p>
          <h3 className="mt-6 md:mt-16 mb-4">Contact</h3>
          <p className="mb-3">
          Bankjoy is always open to feedback, questions, and suggestions. If you would like to talk to us, please feel free to email us at security@bankjoy.com.
          </p>
      </div>
    </Layout>
  )
}
